import React, { useEffect, useState } from 'react'

import { DataContainer, Row } from 'Components/shared/Container'
import { H2 } from 'Components/shared/Typography'
import { getCustomLinks } from 'Store/clubs'
import { Button } from 'Components/shared/Button'

import { CustomLinkTable } from './Table'
import Create from './Create'

export default ({ club, masterClub }) => {
  const [customLinks, setCustomLinks] = useState([])
  const [showCreate, setShowCreate] = useState(false)

  useEffect(async () => {
    const fetchedLinks = club.customLinks
    let links
    if (fetchedLinks?.length > 0)
      links = fetchedLinks.map(link => {
        return {
          id: link.id,
          icon: link.icon,
          shortName: decodeURI(link.shortname)
            .replace(/[⁄]/gm, `/`)
            .replace(/&amp;frasl;|&frasl;/g, '/')
            .replace(/&amp;/g, '&'),
          longName: decodeURI(link.longname)
            .replace(/[⁄]/gm, `/`)
            .replace(/&amp;frasl;|&frasl;/g, '/')
            .replace(/&amp;/g, '&'),
          url: link.url
            .replace(/[⁄]/gm, `/`)
            .replace(/&amp;frasl;|&frasl;/g, '/')
            .replace(/&amp;/g, '&'),
          deleted: link.deleted === 0 ? 'True' : 'False'
        }
      })
    setCustomLinks(links)
  }, [masterClub])

  const updateLinks = async ({ ids }) => {
    const fetchedLinks = await getCustomLinks({ ids })
    const links = fetchedLinks.map(link => {
      return {
        id: link.id,
        icon: link.icon,
        shortName: decodeURI(link.shortname)
          .replace(/[⁄]/gm, `/`)
          .replace(/&amp;frasl;|&frasl;/g, '/')
          .replace(/&amp;/g, '&'),
        longName: decodeURI(link.longname)
          .replace(/[⁄]/gm, `/`)
          .replace(/&amp;frasl;|&frasl;/g, '/')
          .replace(/&amp;/g, '&'),
        url: link.url
          .replace(/[⁄]/gm, `/`)
          .replace(/&amp;frasl;|&frasl;/g, '/')
          .replace(/&amp;/g, '&')
      }
    })
    setCustomLinks(links)
    setShowCreate(false)
  }

  return (
    <>
      <DataContainer>
        <Row style={{ margin: '10px' }}>
          <H2>Custom Links</H2>
        </Row>
        <Row style={{ margin: '10px' }}>
          {!showCreate && (
            <Button
              onClick={() => {
                setShowCreate(!showCreate)
              }}
            >
              Add New Custom Link
            </Button>
          )}
          {showCreate && (
            <Create selectedClub={club} updateLinks={updateLinks} customLinks={customLinks} />
          )}
        </Row>
        <Row style={{ margin: '10px' }}>
          <CustomLinkTable
            customLinks={customLinks}
            setCustomLinks={setCustomLinks}
            updateLinks={updateLinks}
          />
        </Row>
      </DataContainer>
    </>
  )
}
